import slugify from "slugify";

export const slugifyUrl = (string: string) => {
  string = string.replace(/[<>$%&|]+/g, "");
  return slugify(string, {
    replacement: "-",
    lower: true,
    remove: /[*+~.()'"!:@$%&<>]/g,
    strict: true,
  });
};
